import DisplayDataServer from "../../components/admin/DisplayDataServer";

const Services=()=>{

   return <DisplayDataServer name={"Services"} type={"services"}/>;
}
export default Services;